module dg.lists {
    import DG_DATA_TYPES = dg.restfulApi.DG_DATA_TYPES;
    import DG_PROPERTY_TYPES = dg.restfulApi.PropertyType;
    import DG_LINK_RELS = dg.restfulApi.DG_LINK_RELS;

    export class GridListConfigurationService {

        public constructor(
            private $filter: dgUtils.IFilterService,
            private uibDatepickerPopupConfig,
            private uiDatetimePickerConfig) {
        }

        public initMetaOptions(queryManipulator: dg.actions.QueryManipulator, listOptions: IGridListOptions): uiGrid.IGridOptions {
            let query = queryManipulator.query;
            let listPagingOptions = queryManipulator.pagingOptions;
            let queryResult = queryManipulator.result;

            // var paginationEnabled: boolean = listPagingOptions.totalCount > queryResult.items.length;
            let uiGridOptions: uiGrid.IGridOptions = {
                //rowHeight: 60, //two line grid
                //rowHeight: 43,

                enableHorizontalScrollbar: 0, //never
                enableVerticalScrollbar: 0,//never 2,//when needed not working
                enableRowSelection: false,

                //TODO: Use the equivalent in ui grid?
                //enableHighlighting: true,

                //Infinite Scroll http://ui-grid.info/docs/#/tutorial/212_infinite_scroll
                //infiniteScrollRowsFromEnd: 40,
                //infiniteScrollUp: true,
                //infiniteScrollDown: true,

                totalItems: queryResult.totalCount,
                enableSorting: true,

                enableColumnMenus: false,
                enablePaginationControls: false,
                enablePagination: false,
                useExternalPagination: true,
                paginationPageSizes: [20, 50, 100],
                paginationPageSize: 50,
                flatEntityAccess: true,
                headerTemplate: '/digmo/src/lists/grid-list/templates/header.html',
                //fastWatch: true,
                rowTemplate: '/digmo/src/lists/grid-list/templates/row.html'
            };

            if (listPagingOptions && listPagingOptions.pageSize) {
                uiGridOptions.paginationPageSize = listPagingOptions.pageSize;
            }

            uiGridOptions['useExternalSorting'] = true;


            //_.mergeWith(uiGridOptions, listOptions.uiGrid, (value, defaultValue) => {
            //    return angular.isDefined(value) ? value : defaultValue;
            //});

            uiGridOptions = dgUtils.ObjectHelperService.mergeDeep(uiGridOptions, listOptions.uiGrid);

            if (queryResult.dgMeta) {
                uiGridOptions.columnDefs = this.createColumnDefs(queryManipulator, listOptions);
            }

            return uiGridOptions;
        }

        public createColumnDefs(queryManipulator: dg.actions.QueryManipulator, listOptions: IGridListOptions) {

            var query = queryManipulator.query;
            var queryResult = queryManipulator.result;


            var gridColumnDefs = [];

            var itemIndex = 0;
            var keysCount = Object.keys(queryResult.dgMeta.properties).length;

            angular.forEach(queryResult.dgMeta.properties, (propMeta: dg.restfulApi.DomainObjectPropertyMetadata, propName: string) => {
                if (propMeta.dataType == DG_DATA_TYPES.ExternalFile) {
                    //do not visualize external files in the grid
                    return;
                }

                itemIndex++;
                var columnDef: any = this.createGridColumnDef(listOptions, propMeta, itemIndex);
                //columnDef.minWidth = "10%";
                if (angular.isUndefined(columnDef.width)) {
                    columnDef.width = this.getWidth(keysCount, itemIndex);
                }

                gridColumnDefs.push(columnDef);
            });

            if (listOptions.actionColumnEnabled) {
                gridColumnDefs.push({
                    name: 'actions', displayName: '',
                    cellTemplate: '/digmo/src/lists/grid-list/templates/row-actions-cell.html',
                    enableSorting: false, width: 40, headerCellClass: 'action-col', cellClass: 'action-col'
                });
            }

            return gridColumnDefs;
        }

        getWidth(keysCount: number, itemIndex: number) {
            if (keysCount > 1) {
                if (itemIndex > 1) {
                    return "*";
                }
                else {
                    return "20%";
                }
            }
            else {
                return "90%";
            }
        }

        createGridColumnDef(listOptions: IGridListOptions,
            propMeta: dg.restfulApi.DomainObjectPropertyMetadata, itemIndex: number) {
            let columnDef = this.createDefaultColumnDef(listOptions, propMeta, itemIndex);

            if (!!listOptions.uiGrid && !!listOptions.uiGrid.columnDefs) {
                var customColumnDef = listOptions.uiGrid.columnDefs.filter((colDef) => {
                    return colDef.field == propMeta.id;
                })[0];
                if (!!customColumnDef) {
                    //_.mergeWith(columnDef, customColumnDef, (value, defaultValue) => {
                    //    return angular.isDefined(value) ? value : defaultValue;
                    //});

                    columnDef = dgUtils.ObjectHelperService.mergeDeep(columnDef, customColumnDef);
                }
            }

            return columnDef
        }

        itemSelected(item) {
            console.log(item)
        }

        createDefaultColumnDef(listOptions: IGridListOptions,
            propMeta: dg.restfulApi.DomainObjectPropertyMetadata, itemIndex: number) {
            var columnDef: uiGrid.IColumnDef = {
                field: propMeta.id,
                displayName: propMeta.displayName,
                enableSorting: propMeta.sortable
            };

            let cellTemplateName = 'default';
            //default cell template

            //TODO: remove cell filters on account of property-displayer-filter
            if (propMeta.propertyType == "Reference") {
                if (propMeta.multiple) {
                    cellTemplateName = 'ref-multi-values';
                } else {
                    if (propMeta.id == "aggregate") {
                        if (listOptions.selectionType == 'single') {
                            cellTemplateName = 'selectable-item'
                        }
                        else {
                            cellTemplateName = 'ref-self-link';
                        }
                    } else {
                        cellTemplateName = 'ref-link';
                    }

                }

                //} else if (propMeta.dataType == DG_DATA_TYPES.date) {
                //    columnDef.cellFilter = 'date:\'' + this.uibDatepickerPopupConfig.datepickerPopup + '\'';
                //    columnDef.cellClass = 'cellToolTip';
                //} else if (propMeta.dataType == DG_DATA_TYPES.dateTime) {
                //    columnDef.cellFilter = 'date:\'' + this.uiDatetimePickerConfig.dateFormat + '\'';
                //    columnDef.cellClass = 'cellToolTip';
                //} else if (propMeta.dataType == DG_DATA_TYPES.amount) {
                //    columnDef.cellClass = 'number-cell';
                //    columnDef.footerCellClass = 'number-cell';
                //    columnDef.cellFilter = 'number: 2';
                //    columnDef.footerCellTemplate = '<div class="ui-grid-cell-contents" ng-show="col.aggregationType">Total: {{col.getAggregationValue() | number:2 }}</div>';
                //} else if (propMeta.dataType == DG_DATA_TYPES.percent) {
                //    columnDef.cellClass = 'number-cell';
                //    columnDef.footerCellClass = 'number-cell';
                //    columnDef.cellFilter = 'dgFormatPercent';
                //    columnDef.footerCellTemplate = '<div class="ui-grid-cell-contents" ng-show="col.aggregationType">Total: {{col.getAggregationValue() | dgFormatPercent }}</div>';
                //} else if (propMeta.dataType == DG_DATA_TYPES.number) {
                //    columnDef.cellClass = 'number-cell';
                //    columnDef.footerCellClass = 'number-cell';
            } else if (propMeta.dataType == DG_DATA_TYPES.MultilineText) {
                cellTemplateName = 'multilinetext';
            } else if (propMeta.dataType == DG_DATA_TYPES.RichText) {
                cellTemplateName = 'richtext';
            } else if (propMeta.multiple) {
                cellTemplateName = 'multi-values';
            }


            columnDef.cellTemplate = `/digmo/src/lists/grid-list/templates/${cellTemplateName}-cell.html`

            return columnDef;
        }
    }

    angular.module('dg.lists')
        .service('gridListConfigurationService', GridListConfigurationService);
}

